const Wallet = (props) => {
  return (
    <p className="display-items">Cash: ${props.cash}</p>
  )
}

export default Wallet
